import { AppDispatch } from "@portal/redux/store";
import { ClearReduxData } from "../../components/helpers";
import { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";

export const OnFooterClick = (centerId: string, dispatch: AppDispatch, router: AppRouterInstance, primary?: boolean) => {
  if (primary) {
    window.print();
  } else {
    ClearReduxData(dispatch);
    router.push(`/robot/?centerId=${centerId}`);
  }
};
